import React from "react";
import { motion } from "framer-motion";

export const Star = ({ className = "", size = 16, spin = false }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    className={`${className} ${spin ? "star-spin" : ""}`}
    aria-hidden="true"
  >
    <path d="M12 0L13.5 10.5L24 12L13.5 13.5L12 24L10.5 13.5L0 12L10.5 10.5L12 0Z" />
  </svg>
);

const ease = [0.33, 1, 0.68, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, ease, delay }}
  >
    {children}
  </motion.div>
);

// Line-by-line masked reveal for hero
export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <span className="block overflow-hidden">
    <motion.span
      className={`block ${className}`}
      initial={{ y: "110%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1.1, ease, delay }}
    >
      {children}
    </motion.span>
  </span>
);

export const Label = ({ children, className = "" }) => (
  <span className={`label text-gold inline-flex items-center gap-3 ${className}`}>
    <Star size={9} />
    {children}
  </span>
);

export const GoldButton = ({ children, className = "", ...props }) => (
  <button
    className={`group inline-flex items-center gap-3 border border-[#D4A843] text-[#D4A843] px-8 py-4 label hover:bg-[#D4A843] hover:text-[#0D1220] transition-colors duration-300 ${className}`}
    {...props}
  >
    {children}
    <span className="inline-block transition-transform duration-300 group-hover:translate-x-1">&#8594;</span>
  </button>
);
